import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import {connect, setStore} from "trim-redux";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import Divider from "@material-ui/core/Divider/Divider";
import TextField from "@material-ui/core/TextField/TextField";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {currencySymbol, truncate} from "../../../config/values";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withRouter,Link} from "react-router-dom";
import {updateRedux} from "../../../config/Security";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button/Button";
import ModifyPriceButton from "./components/ModifyPriceButton";
import SubTitle from "../../components/elements/SubTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import {Pagination} from "@material-ui/lab";
import Chip from "@material-ui/core/Chip/Chip";
import TabletAndroidRoundedIcon from '@material-ui/icons/TabletAndroidRounded';
import MicNoneRoundedIcon from '@material-ui/icons/MicNoneRounded';
import ImportContactsRoundedIcon from '@material-ui/icons/ImportContactsRounded';
import {ArrowBackRounded} from "@material-ui/icons";

class BulkPricing extends React.Component {
    classes = this.props.classes;
    state = {
        loading:true,
        shop:null,
        pricings:[],
        total_pages:0,
        current_page:1,
        shop_id:this.props.shop_id,
    };
    async componentDidMount(){
        await this.setState({
            shop_id:this.props.shop_id,
        })
        await this.loadData();
    }
    async componentDidUpdate(prevProps){
        if(this.state.shop_id !== this.props.shop_id){
            await this.setState({
                shop_id: this.props.shop_id
            })
            await this.loadData();
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let {shop_id,current_page} = this.state;
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/get-pricings/bulk/${shop_id}?page=${current_page}`, config)
                .then(response => {
                    this.setState({
                        loading : false,
                        pricings : response.data.pricings.data,
                        shop : response.data.shop,
                        total_pages : parseInt(response.data.pricings.last_page),
                    });

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading : false,
                    });
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(field,id,index,val){
        let {pricings} = this.state;
        pricings[index][field] = val
        this.setState({
            pricings,
        })
    }
    async handleCurrentPage(current_page){
        await this.setState({
            loading:true,
            current_page
        })
        await this.loadData();
    }
    async handleBlur(field,id,index,val){
        this.setState({
            submit_loading:id
        })
        let {pricings} = this.state;
        let data = new FormData();
        data.append('field', field);
        data.append('id', id);
        if(field === "price" || field === "discount_price"){
            val = val.replace(/,/ig, '')
        }
        data.append('val', val);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/pricing/bulk-edit`, data, config)
            .then(response => {
                pricings[index] = response.data
                this.setState({
                    pricings,
                    submit_loading:false
                })
            })
            .catch(error => {
                console.log(error)
                pricings[index] = error.response.data
                this.setState({
                    pricings,
                    submit_loading:false
                })

            });

    }
    render(){
        let {manage} = this.props;
        let {pricings,loading,submit_loading,shop} = this.state;
        return (
            <Grid container spacing={2}>
                {
                    !!loading ?
                        <AppCardLoaderFields/>
                        :
                        <>
                            {
                                !!manage &&
                                <Grid item xs={12} style={{background:"#fdfdfd",padding:10,borderRadius:4,display:"flex",justifyContent:"space-between"}}>
                                    <SubTitle align="left">{Translate.shop}
                                        <Button
                                            color="primary"
                                            component="a"
                                            target="_blank"
                                            href={`${defaultVariabls.website}/vendor/${shop.slug}`}
                                        >
                                            {shop.name}
                                        </Button>
                                    </SubTitle>
                                    <Tooltip title={Translate.editShop}>
                                        <IconButton
                                            color="primary"
                                            component={Link}
                                            to={`/edit/shop/${shop.id}`}
                                            size={"small"}

                                            style={{marginBottom:5,marginRight:5}}
                                        >
                                            <ArrowBackRounded fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            }

                            {
                                pricings.map((pricing,index) => (
                                    <Grid item xs={12} key={index}>
                                        <Grid container spacing={2} justify="center">
                                            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                <div>
                                                    <Typography>
                                                        <Tooltip title={!pricing.product.confirmed ? Translate.unconfirmed_product : pricing.product.name}>
                                                            <Button
                                                                color="primary"
                                                                disabled={!pricing.product.confirmed}
                                                                component="a"
                                                                target="_blank"
                                                                size="small"
                                                                href={`${defaultVariabls.website}/product/${pricing.product.slug}`}
                                                            >
                                                                {truncate(pricing.product.name,20)}
                                                            </Button>
                                                        </Tooltip>
                                                        <Chip
                                                            label={Translate[pricing.product.physically]+" "+(pricing.product.physically === "physical" ? Translate[pricing.product.situation] : "")}
                                                            size="small"
                                                            color="secondary"
                                                            variant="outlined"
                                                            style={{margin:"0 5px",fontSize:12,padding:5,border:"none"}}
                                                            icon={
                                                            pricing.product.physically === "physical" ?
                                                                <ImportContactsRoundedIcon fontSize="small"/>
                                                                :
                                                                pricing.product.physically === "audiobook" ?
                                                                    <MicNoneRoundedIcon fontSize="small"/>
                                                                    :
                                                                    <TabletAndroidRoundedIcon fontSize="small"/>
                                                        }
                                                        />
                                                        <small>
                                                            {pricing.product.unique_code}
                                                        </small>
                                                    </Typography>
                                                </div>
                                                <div style={{display:"flex",alignItems:"center"}}>
                                                    {
                                                        submit_loading === pricing.id &&
                                                        <CircularProgress size={24}/>
                                                    }
                                                    <ModifyPriceButton
                                                        icon
                                                        manage={manage}
                                                        id={pricing.id}
                                                        reload={() => this.loadData()}
                                                    />
                                                </div>

                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <TextField
                                                    select
                                                    required
                                                    type="text"
                                                    size="small"
                                                    fullWidth
                                                    label={Translate.pricing_status}
                                                    name="pricing_status"
                                                    value={pricing.inventory === 0 && pricing.status === "present" ? "sold" :  pricing.status}
                                                    variant="outlined"
                                                    onChange={(e) => this.handleBlur('status',pricing.id,index,e.target.value)}
                                                >
                                                    <MenuItem value={'present'}>
                                                        {pricing.product.physically === "physical" ? Translate.present_pricing : Translate.present_pricing_virtual}
                                                    </MenuItem>
                                                    {
                                                        pricing.product.physically === "physical" &&
                                                        <MenuItem value={'unlimited'}>
                                                            {Translate.unlimited}
                                                        </MenuItem>
                                                    }
                                                    <MenuItem value={'sold'}>
                                                        {pricing.product.physically === "physical" ? Translate.sold_pricing : Translate.sold_pricing_virtual}
                                                    </MenuItem>
                                                    <MenuItem value={'soon'}>
                                                        {Translate.soon_pricing}
                                                    </MenuItem>
                                                    <MenuItem value={'free'}>
                                                        {Translate.free_pricing}
                                                    </MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <CurrencyTextField
                                                    required
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={pricing.price}
                                                    id="price"
                                                    label={Translate.price}
                                                    name="price"
                                                    onChange={(e) => this.handleChange('price',pricing.id,index,e.target.value)}
                                                    onBlur={(e) => this.handleBlur('price',pricing.id,index,e.target.value)}

                                                />
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={pricing.discount_price}
                                                    id="discount_price"
                                                    label={Translate.discount_price}
                                                    name="discount_price"
                                                    onChange={(e) => this.handleChange('discount_price',pricing.id,index,e.target.value)}
                                                    onBlur={(e) => this.handleBlur('discount_price',pricing.id,index,e.target.value)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                {
                                                    ((pricing.status === "present" || pricing.status === "free") && pricing.product.physically === "physical") &&
                                                    <TextField
                                                        required
                                                        variant="outlined"
                                                        value={pricing.inventory}
                                                        fullWidth
                                                        size="small"
                                                        type="number"
                                                        label={Translate.inventory}
                                                        placeholder={Translate.inventoryDesc}
                                                        name="inventory"
                                                        onChange={(e) => this.handleChange('inventory',pricing.id,index,e.target.value)}
                                                        onBlur={(e) => this.handleBlur('inventory',pricing.id,index,e.target.value)}
                                                    />
                                                }

                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))
                            }

                            {
                                this.state.total_pages > 1 &&
                                <Grid item xs={12}>
                                    <Pagination count={this.state.total_pages} page={this.state.current_page} onChange={(e,val) => this.handleCurrentPage(val)} />
                                </Grid>
                            }
                        </>
                }
            </Grid>
        );
    }
}
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(BulkPricing))));